import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.dialog = this.element.closest("dialog")

    if (this.dialog) {
      this.observer = new MutationObserver(() => {
        if (this.dialog.open) {
          this.markAsRead()
        }
      })
      this.observer.observe(this.dialog, { attributes: true, attributeFilter: ["open"] })

      this.boundOnClose = () => this.applyPendingStream()
      this.dialog.addEventListener("close", this.boundOnClose)
    } else {
      this.markAsRead()
    }
  }

  markAsRead() {
    if (!this.hasUrlValue) return

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.text()
        }
      })
      .then((html) => {
        if (!html) return

        if (this.dialog?.open) {
          this.pendingStreamHtml = html
        } else {
          Turbo.renderStreamMessage(html)
        }
      })
  }

  applyPendingStream() {
    if (this.pendingStreamHtml) {
      Turbo.renderStreamMessage(this.pendingStreamHtml)
      this.pendingStreamHtml = null
    }
  }

  disconnect() {
    this.observer?.disconnect()
    this.dialog?.removeEventListener("close", this.boundOnClose)
  }
}
